import React, { FC, useContext } from 'react';
import { FormValuesContext, ContentContext, ViewportContext } from '../../../index.contexts';
import { DATES, ROOMS_AND_GUESTS } from '../../../constants/StoreConstants';
import { getValueFromDate } from '../../../utils/DateUtils';
import { DATE_FORMAT_VALUE, DAY_MONTH_YEAR_FORMAT } from '../../../constants/ApplicationConstants';
// import UnknownFields from './unknownFields';

declare global {
  interface Window {
    destinationMetaDataDetails: {
      isStateEnabled: '';
      isCountryEnabled: '';
      state: '';
      country: '';
      destinationName: '';
    };
  }
}

const HiddenFields: FC<{ isPublishUserSelection?: boolean; acceptLanguage?: string; isMPO?: boolean }> = ({
  isPublishUserSelection = false,
  acceptLanguage,
  isMPO = false,
}) => {
  const { formValues } = useContext(FormValuesContext);
  // const isMobileView = useContext(ViewportContext);
  const { localDateFormat, marshaCode, offerId } = useContext(ContentContext);
  // const { marshaCode, offerId } = useContext(ContentContext);
  // const hiddenFieldsValues = formValues?.[DESTINATION_HIDDEN_FIELDS];
  // const splRatesHiddenFields = formValues?.[SPECIAL_RATES];
  // const { displayText: destinationName } = formValues?.[DESTINATION] ?? {};
  const getRooms = formValues?.roomsAndGuests?.roomsCount;
  let destination = '';

  if (window?.destinationMetaDataDetails) {
    const { isStateEnabled, isCountryEnabled, state, country, destinationName } = window.destinationMetaDataDetails;
    const stateValue = state ? `, ${state}` : '';
    const countryValue = country ? `, ${country}` : '';

    destination = `${destinationName}${stateValue}${countryValue}`;

    if (isStateEnabled) {
      destination = `${destinationName}${countryValue}`;
    } else if (isCountryEnabled) {
      destination = `${destinationName}`;
    }
  }
  const isUpdatedFormat = (): boolean => {
    const dateFlag =
      acceptLanguage === 'it-IT' ||
      acceptLanguage === 'fr-FR' ||
      acceptLanguage === 'pt-BR' ||
      acceptLanguage === 'es-ES' ||
      acceptLanguage === 'en-GB'
        ? true
        : false;
    return dateFlag;
  };

  /** Add dates value computation */
  const datesValues = formValues?.[DATES] ?? {};
  const { fromDate, toDate } = datesValues;
  // const fromDate = getDateObject('2021-12-01', DATE_FORMAT_VALUE) ;
  // const toDate = getDateObject('2022-06-30', DATE_FORMAT_VALUE);
  // const dateFormat = (localDateFormat as string) ?? DATE_FORMAT_VALUE;
  const dateFormat = localDateFormat ? localDateFormat : isUpdatedFormat() ? DAY_MONTH_YEAR_FORMAT : DATE_FORMAT_VALUE;

  const { flexible } = datesValues;
  const numberOfNights = Math.ceil(toDate?.diff(fromDate, 'days', true) ?? 0);
  const fromDateValue = getValueFromDate(fromDate, dateFormat);
  const toDateValue = getValueFromDate(toDate, dateFormat);
  const fromToDateValue = toDateValue;
  const { roomsCount, adultsCount, childrenCount, childrenAges } = formValues?.[ROOMS_AND_GUESTS] ?? {};
  const childrenAgesString = childrenAges?.map(age => (isNaN(Number(age)) ? 0 : age)).toString();
  const roomsCountValue = roomsCount ? parseInt(roomsCount, 10).toString() : '';
  const clusterCode = formValues?.destination?.clusterCode === '0' ? 'none' : 'corp';
  const propCode = marshaCode as string;
  const offerIdValue = offerId as string;
  const hiddenFieldsValues = formValues?.destinationHiddenFields;
  const isMobileView = useContext(ViewportContext);
  const { displayText: destinationName } = formValues?.destination ?? {};
  // const destinationValue = `${hiddenFieldsValues?.city ?? ''}${hiddenFieldsValues?.state ?? ''}${hiddenFieldsValues?.country ?? ''}`;

  // Inputs only for MPOs

  /*eslint-disable @typescript-eslint/no-explicit-any*/
  const MPOInputs = (): any => {
    /*eslint-enable @typescript-eslint/no-explicit-any*/
    return (
      <span className="no-display" hidden>
        {/* New  params for find hotels search starts */}
        <input type="hidden" name="dateFormatPattern" value={''} />
        <input type="hidden" name="minDate" value={''} />
        <input type="hidden" name="searchCriteriaVO.city" value={hiddenFieldsValues?.city ?? ''} />
        <input type="hidden" name="searchCriteriaVO.country" value={hiddenFieldsValues?.country ?? ''} />
        <input type="hidden" name="searchCriteriaVO.destination" value={destinationName} />
        <input type="hidden" name="searchCriteriaVO.spcunits" value={''} />
        <input type="hidden" name="pageType" value={'advanced'} />
        <input type="hidden" name="searchCriteriaVO.searchRadius" value={hiddenFieldsValues?.radius ?? ''} />
        <input type="hidden" name="searchCriteriaVO.guestRoomCount" value={roomsCountValue ?? ''} />
        <input type="hidden" name="searchCriteriaVO.latitude" value={hiddenFieldsValues?.latitude ?? ''} />
        <input type="hidden" name="searchCriteriaVO.longitude" value={hiddenFieldsValues?.longitude ?? ''} />
        <input type="hidden" name="searchCriteriaVO.stateProvince" value={hiddenFieldsValues?.state ?? ''} />
        <input type="hidden" name="useRequestCriteria" value="true" />
        {getRooms !== '10-25' && <input type="hidden" name="showErrors" value="true" />}

        {/* New  params for find hotels search ends */}
      </span>
    );
  };

  return (
    <span className="no-display" hidden>
      {/* PArent wrapper cannot have longer DOM's. Loading unnecessary fields */}

      {/* DestinationFields start */}

      <input
        type="hidden"
        name="destinationAddress.types"
        value={hiddenFieldsValues?.types ?? ''}
        className="destination-types"
      />
      <input
        type="hidden"
        name="destinationAddress.latitude"
        value={hiddenFieldsValues?.latitude ?? ''}
        className="search-latitude"
      />
      {/* <input type="hidden" name="searchCriteriaVO.destination" value={destination} /> */}

      {isPublishUserSelection && (getRooms === '10-25' || getRooms === '26+') ? (
        <input type="hidden" name="destinationAddress.destination" value={destination} />
      ) : (
        ''
      )}
      {isMobileView ? (
        <input
          type="hidden"
          name="destinationAddress.destination"
          value={destinationName ? destinationName : destination}
        />
      ) : (
        ''
      )}
      <input
        type="hidden"
        name="destinationAddress.stateProvince"
        value={hiddenFieldsValues?.state ?? ''}
        className="search-state js-search-state destinationAddress.stateProvince"
      />
      <input
        type="hidden"
        name="searchRadius"
        value={hiddenFieldsValues?.radius ?? ''}
        className="searchRadius js-search-radius"
      />
      <input
        type="hidden"
        name="destinationAddress.placeId"
        value={hiddenFieldsValues?.placeId ?? ''}
        className="search-place-id"
      />
      <input
        type="hidden"
        name="destinationAddress.country"
        value={hiddenFieldsValues?.country ?? ''}
        className="search-country js-search-country destinationAddress.country"
      />
      <input
        type="hidden"
        name="destinationAddress.address"
        value={hiddenFieldsValues?.address ?? ''}
        className="destination-address"
      />
      <input
        type="hidden"
        name="destinationAddress.secondaryText"
        value={hiddenFieldsValues?.secondaryDescription ?? ''}
        className="search-secondary-description"
      />
      <input
        type="hidden"
        name="destinationAddress.postalCode"
        value={hiddenFieldsValues?.postalAddress ?? ''}
        className="destination-postal-code"
      />
      <input
        type="hidden"
        name="destinationAddress.city"
        value={hiddenFieldsValues?.city ?? ''}
        className="search-city js-search-city hotel-city-airport"
      />
      <input
        type="hidden"
        name="destinationAddress.mainText"
        value={hiddenFieldsValues?.primaryDescription ?? ''}
        className="search-primary-description"
      />
      <input type="hidden" name="isTransient" value="true" />
      <input
        type="hidden"
        name="destinationAddress.longitude"
        value={hiddenFieldsValues?.longitude ?? ''}
        className="search-longitude"
      />
      <input
        type="hidden"
        name="destinationAddress.website"
        value={hiddenFieldsValues?.website ?? ''}
        className="destination-website"
      />

      {/* DestinationFields End */}

      <input type="hidden" name="recordsPerPage" value="20" />
      <input type="hidden" name="roomTypeCode" value="" />
      <input type="hidden" name="propertyCode" value={propCode ?? ''} />
      <input type="hidden" name="isInternalSearch" value="true" />
      <input type="hidden" name="vsInitialRequest" value="false" />
      <input type="hidden" name="isTransient" value="true" />
      <input type="hidden" name="initialRequest" value="true" />
      <input type="hidden" name="corporateCode" value={formValues?.destination?.clusterCode} />
      <input type="hidden" name="clusterCode" value={clusterCode ?? 'corp'} />
      <input type="hidden" name="marrOfferId" value={offerIdValue ?? ''} />
      <input type="hidden" name="lengthOfStay" value={numberOfNights ?? 1} />
      <input type="hidden" name="numberOfRooms" value={roomsCountValue ?? ''} />
      <input type="hidden" name="numberOfAdults" value={adultsCount ?? ''} />
      <input type="hidden" name="childrenCount" value={childrenCount ?? ''} />
      <input type="hidden" name="childrenAges" value={childrenAgesString ?? ''} />
      <input type="hidden" name="fromToDate" value={formValues?.[DATES]?.lastDefaultDate ?? ''} />
      <input type="hidden" name="fromToDate_submit" value={fromToDateValue ?? ''} />
      <input type="hidden" name="fromDate" value={fromDateValue ?? ''} />
      <input type="hidden" name="toDate" value={toDateValue ?? ''} />
      <input type="hidden" name="toDateDefaultFormat" value={toDateValue ?? ''} />
      <input type="hidden" name="fromDateDefaultFormat" value={fromDateValue ?? ''} />
      <input type="hidden" name="roomCount" value={roomsCountValue ?? ''} />
      <input type="hidden" name="numAdultsPerRoom" value={adultsCount ?? ''} />
      {/* <input type="hidden" name="searchCriteriaVO.destination" value={destination} /> */}
      {/* <input type="hidden" name="roomCountBox" value={getRooms+'+Rooms'?? ''} /> */}
      <input type="hidden" name="flexibleDateSearch" value={(!!flexible).toString() ?? ''} />
      {isPublishUserSelection && (getRooms === '10-25' || getRooms === '26+') ? (
        <input type="hidden" name="destinationAddress.destination" value={destination} />
      ) : (
        ''
      )}

      {isMPO ? <MPOInputs></MPOInputs> : ''}
    </span>
  );
};

export default HiddenFields;
